import { render, staticRenderFns } from "./RecoverPasswordSubmit.vue?vue&type=template&id=6792f17b"
import script from "./RecoverPasswordSubmit.vue?vue&type=script&lang=js"
export * from "./RecoverPasswordSubmit.vue?vue&type=script&lang=js"
import style0 from "./RecoverPasswordSubmit.vue?vue&type=style&index=0&id=6792f17b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports